export default "__VITE_ASSET__c98d749e__"